import React, { Component } from 'react';
import icona from '../img/bren.jpg'
import  Nav from './nav'
import '../css/about.css';


class About extends Component {

render(){
return(<div>
<Nav/>

<div class="container">

<div class="row">

<div class="col-md-12" >
<center>
<h1 id="titules2">SOBRE MÍ</h1>

</center>
</div>

</div>

<div class="row">

    <div class="col-md-6" id="containers" >
   
    <center>
    <div class="text-justify"> 
    <p> ¡Hola! Soy Brenda Morales.</p>
  

    <p>Soy Front End Developer e Ingeniera en Telecomunicaciones.</p> 
    <p>Tengo 24 años y soy una apasionada del aprendizaje permanente 
    y las colaboraciones fructíferas.</p>
    <p> Me interesa brindar soluciones innovadoras centradas 
    en el usuario a través de los recursos tecnológicos y el desarrollo humano. </p>
    <p> Yo me defino como una persona creativa, autodidácta, perseverante y curiosa.</p>
      Amante de las caminatas largas, libros y una taza de té.</div>
</center> 
    </div>
    <div class="col-md-6 pt-4" >
   
    
    
   
    <center> 
    
    <img src={icona} alt="logo" id="imga"/>
    </center> 
   
    
  
   
    
    </div>
   
  </div>
​
</div>
</div>);
}
}
export default About; 